<template>
    <vx-table-row data-test="externalList-row">
        <vx-table-row-title class="md:!vx-col-span-full lg:!vx-col-auto">
            <div>{{ externalList.name }}</div>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Contacts: </template>
            <font-awesome-icon
                v-if="contactsCount[externalList.id] == undefined"
                :icon="faLoader"
                spin
            ></font-awesome-icon>
            <template v-else>
                <span data-test="contacts-count">
                    {{ formatCount(contactsCount[externalList.id]) }}
                </span>
            </template>
        </vx-table-row-item>

        <vx-table-row-item>
            <div>{{ externalList.vendor }}</div>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Created: </template>

            <vx-popover
                hover
                :arrow="true"
                placement="top"
                :key="externalList.created_at"
                :class="dateTextColor(externalList.created_at)"
            >
                {{ fromNow(externalList.created_at) }}
                <template v-slot:content>
                    {{ shortDateTime(externalList.created_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <external-list-row-dropdown :externalList="externalList"></external-list-row-dropdown>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script setup>
import { VxTableRow, VxTableRowItem, VxTableRowTitle, VxTableRowButtons, VxPopover } from '@voxie/frontend-components';
import { fromNow, shortDateTime, dateTextColor } from '~/utils/date';
import ExternalListRowDropdown from './ExternalListRowDropdown.vue';
import { faLoader } from '@fortawesome/pro-solid-svg-icons';
import { formatCount } from '~/components/filters';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useExternalListsContactCount } from '~/composables/useExternalListsContactCount';

const { contactsCount } = useExternalListsContactCount();

defineProps({
    externalList: {
        type: Object,
        required: true,
    },
});
</script>
